export const ClearTrackServiceBaseUrl  = 'https://api.cleartrack.warnerbros.com';
export const clearTrackServiceWSBaseUrl = 'wss://uhm5yerf5f.execute-api.us-west-2.amazonaws.com/prod';
export const OKTA_CLIENT_ID = "0oaaiifq9aGgOwIzp4x7";
export const OKTA_ISSUER_URL = "https://ssobiz.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + '/callback';
export const OKTA_URL = "https://ssobiz.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";